import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ContextMenuProvider } from "mantine-contextmenu";
import { AlertModalProvider } from "./AlertModal";
import ColorThemeProvider from "./ColorThemeProvider";
import { UserProvider } from "./web/UserContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ColorThemeProvider>
      <UserProvider>
        <AlertModalProvider>
          <ContextMenuProvider>
            <App />
          </ContextMenuProvider>
        </AlertModalProvider>
      </UserProvider>
    </ColorThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
